import clv from "./clv.webp";
import fp from "./foris private.webp";
import cm from "./cemara mansion.webp";


const clvImages = [clv, clv];
const fpImages = [fp, fp];
const cmImages = [cm, cm];

export { clvImages, fpImages, cmImages };
